import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default Wrapper;
